import { render, staticRenderFns } from "./most-favourite.vue?vue&type=template&id=b6e1ba10"
import script from "./most-favourite.vue?vue&type=script&lang=js"
export * from "./most-favourite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports